// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="11.8995"
				y="3.41421"
				width="12"
				height="12"
				transform="rotate(45 11.8995 3.41421)"
				stroke={props.color}
				strokeWidth="2"
			/>
		</svg>
	</>
);

export default Icon;
